import Queue from 'src/helpers/Queue'
import EventEmitter from 'src/helpers/EventEmitter'

const THREE = (window.THREE = require('three'))
import GLTFLoader from '@/libs/three/loader/GLTFLoader.js'
import DRACOLoader from '@/libs/three/loader/DRACOLoader.js'
import BasisTextureLoader from '@/libs/three/loader/BasisTextureLoader.js'

import { ASSET_TYPES } from 'src/services/ThreeService/const'

const Events = {
  COMPLETED: 'completed',
  ITEM_COMPLETE: 'item_complete',
}

let AssetsMap = function () {
  return {
    [ASSET_TYPES.TEXTURE]: {},
    [ASSET_TYPES.GLTF]: {},
    [ASSET_TYPES.BASIS_TEXTURE]: {},
  }
}

class ThreeService {
  constructor() {
    Object.assign(this, EventEmitter, {
      _progress: 0,
      _totalprogress: 0,
      _numOfItems: 0,
      complete: false,
    })

    this.assets = new AssetsMap()

    const manager = new THREE.LoadingManager()

    const basisLoader = new THREE.BasisTextureLoader(manager)
    basisLoader.setTranscoderPath('/js/libs/three/basis/')
    basisLoader.detectSupport(new THREE.WebGLRenderer())

    const gltfLoader = new THREE.GLTFLoader(manager)
    const textureLoader = new THREE.TextureLoader(manager)
    // loader.setCrossOrigin('anonymous')

    // const dracoLoader = new THREE.DRACOLoader()
    // dracoLoader.setDecoderPath('js/libs/three/basis/')
    // gltfLoader.setDRACOLoader(dracoLoader)

    this.typeMap = {
      [ASSET_TYPES.GLTF]: {
        loader: gltfLoader,
        processor: (item, asset) => {},
      },

      [ASSET_TYPES.TEXTURE]: {
        loader: textureLoader,
        processor: (item, asset) => {
          if (item.mipmap === false) {
            asset.magFilter = THREE.LinearFilter
            asset.minFilter = THREE.LinearFilter
            asset.needsUpdate = true
          }

          asset.flipY = !!item.flipY
          asset.needsUpdate = true
        },
      },

      [ASSET_TYPES.BASIS_TEXTURE]: {
        loader: basisLoader,
        processor: (item, asset) => {},
      },
    }
  }

  load = (manifest, concurrency = 2, groudId = '') => {
    this.groudId = groudId
    return new Promise((resolve, reject) => {
      if (this.groudId !== '') {
        let group = manifest.find(group => group.id === this.groudId)
        if (group) {
          this._totalprogress = 0
          this._progress = 0
          this._numOfItems = group.items.length

          let q = new Queue(concurrency)

          for (const item of group.items) {
            // console.log(item.url)
            //if (!/\.(glb|gltf|png|jpg|jpeg)$/i.test(item.url)) {
            q.add(() => {
              return this._loadItem(item)
            })
            // } else {
            //   console.log('INCORRECT FILE')
            // }
          }

          q.on(Queue.Events.EMPTY, gltf => {
            this.complete = true
            this.emit(Events.COMPLETED)
            if (this._totalprogress === 1) {
              resolve()
            }
          })
        } else {
          reject()
        }
      } else {
        reject()
      }
    })
  }

  _loadItem = item => {
    return new Promise((resolve, reject) => {
      let loader = this.typeMap[item.type].loader
      if (!this.assets[item.id]) {
        loader.load(
          item.url,
          asset => {
            this.typeMap[item.type].processor(item, asset) //process (configuration etc)
            this.assets[item.id] = asset
            this.assets[item.type][item.id] = asset

            this._progress++
            this._totalprogress = this._progress / this._numOfItems
            this.emit(Events.PROGRESS, this._totalprogress)
            this.emit(Events.ITEM_COMPLETE, item.id)
            // console.log(item.id)
            resolve()
          },
          event => {
            if (event.total) {
              this._totalprogress = this._progress / this._numOfItems
              this._totalprogress += event.loaded / event.total / this._numOfItems
              this.emit(Events.PROGRESS, this._totalprogress)
            }
          },
          err => {
            console.log(item.id)
            console.log(err)
            reject(err)
          }
        )
      } else {
        resolve()
      }
    })
  }

  get = id => {
    return this.assets[id]
  }

  get progress() {
    return this._totalprogress
  }
}

let service = new ThreeService()
service.Events = Events
window.ThreeService = service
export default service
